import HttpEntityClient from '@123/druid/dist/Components/Http/HttpEntityClient';
import {injectable} from '@123/druid/dist/Framework/Decorators/Inject';
import {analyticsScriptSchema, type AnalyticsScript} from '@Module/Tracking/Schema/AnalyticsScript';
import type {UpdateCookieRequest} from '@Module/Tracking/Type/UpdateCookieRequest';
import DomainHelper from '@Utility/Domain/DomainHelper';
import CookieService from '@Service/Cookie/CookieService';

@injectable()
export default class CookieTrackingService {
    private static readonly TRACKING_COOKIES = [
        'kameleoon',
        '_uetvid',
        '_uetsid',
        '_hjSessionUser_',
        '_hjSession_',
        '_gcl_au',
        '_ga',
        '_gat_gtag_UA_',
        '_gid',
        '_fbp',
        '__exponea',
    ];

    constructor(
        protected cookieService: CookieService = new CookieService(),
        private entityClient: HttpEntityClient = new HttpEntityClient(),
    ) {}

    public updateCookiePreferences(body: UpdateCookieRequest): Promise<AnalyticsScript> {
        return this.entityClient.post('/action/update-cookie-preferences.json', body, analyticsScriptSchema);
    }

    public async removeTrackingCookies(): Promise<void> {
        const cookies = await this.cookieService.getCookies();
        const trackingCookies = cookies.filter((cookie) => CookieTrackingService.TRACKING_COOKIES.some((pattern) => cookie.startsWith(pattern)));

        await Promise.all(
            trackingCookies.map((cookie) =>
                this.cookieService.setCookie(
                    {
                        name: cookie,
                        value: '',
                        domain: DomainHelper.getBaseDomain(2),
                        expires: Math.floor(Date.now() / 1000) - 3600,
                    },
                    0,
                    true,
                ),
            ),
        );
    }
}
